import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { IOrderRow } from './Types';
import { Modal, Button } from 'react-bootstrap';

const BasicOrderInfoModal = (props: any) => {
    let settings: any = {
        show: true,
        onHide: props.close
    };
    if (props.large) {
        settings.bsSize = 'large';
    }

    return (
        <Modal {...settings}>
            <Modal.Header closeButton>
                <Modal.Title>{Translate(props.title)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.children}</Modal.Body>
            <Modal.Footer>
                {props.readOnly && (
                    <Button onClick={() => props.close()}>{Translate(props.cancelText)}</Button>
                )}
                {!props.readOnly && (
                    <div>
                        <Button disabled={props.doing} onClick={() => props.close()}>
                            {Translate(props.cancelText)}
                        </Button>
                        <Button disabled={props.doing} bsStyle="primary" onClick={() => props.do()}>
                            {props.doing ? Translate(props.doingText) : Translate(props.doText)}
                        </Button>
                    </div>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default BasicOrderInfoModal;
